import React from 'react'
import { Input, Card, Button } from 'antd'
import { PlusOutlined, DeleteOutlined } from '@ant-design/icons'
import { useFormikContext, FieldArray } from 'formik'
import { FormField, ArrayItemCard, RemoveButton } from './shared'
import { useFieldPath } from './TabContext'
import { get } from 'lodash'

const { TextArea } = Input

export const AboutDetailsSection: React.FC = () => {
  const { values, setFieldValue } = useFormikContext<any>()

  const titlePath = useFieldPath('sections.aboutDetails.title')
  const subtitlePath = useFieldPath('sections.aboutDetails.subtitle')
  const learningTopicsPath = useFieldPath('sections.aboutDetails.learningTopics')

  const learningTopics = get(values, learningTopicsPath, [])

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    setFieldValue(e.target.name, e.target.value)
  }

  return (
    <Card>
      <FormField>
        <label>Título</label>
        <TextArea
          name={titlePath}
          value={get(values, titlePath, '')}
          onChange={handleChange}
          rows={2}
          placeholder="Título da seção"
        />
      </FormField>
      <FormField>
        <label>Subtítulo</label>
        <TextArea
          name={subtitlePath}
          value={get(values, subtitlePath, '')}
          onChange={handleChange}
          rows={2}
          placeholder="Subtítulo da seção"
        />
      </FormField>

      <h4>Tópicos de Aprendizado</h4>
      <FieldArray name={learningTopicsPath}>
        {(arrayHelpers) => (
          <>
            {learningTopics.map((topic, index) => (
              <ArrayItemCard key={index}>
                <RemoveButton>
                  <Button
                    type="text"
                    danger
                    size="small"
                    icon={<DeleteOutlined />}
                    onClick={() => arrayHelpers.remove(index)}
                  />
                </RemoveButton>
                <FormField>
                  <label>Título do Tópico</label>
                  <Input
                    name={`${learningTopicsPath}.${index}.title`}
                    value={topic.title}
                    onChange={handleChange}
                    placeholder="Ex: Prática de Segurança no Transporte"
                  />
                </FormField>
                <FormField>
                  <label>Descrição</label>
                  <TextArea
                    name={`${learningTopicsPath}.${index}.description`}
                    value={topic.description}
                    onChange={handleChange}
                    rows={2}
                    placeholder="Descrição do tópico"
                  />
                </FormField>
              </ArrayItemCard>
            ))}
            <Button
              type="dashed"
              onClick={() => arrayHelpers.push({ title: '', description: '' })}
              block
              icon={<PlusOutlined />}
            >
              Adicionar Tópico de Aprendizado
            </Button>
          </>
        )}
      </FieldArray>
    </Card>
  )
}
